import { io, Socket } from "socket.io-client";

const socket: Socket = io("https://www.servicepro.tn", {
  transports: ["websocket"],
  autoConnect: true,
});

export default socket;
